import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';
import { stopPropagation } from 'src/utils';

const ShoppingCartCatalogCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);
  const { getUrl, redirect } = useRedirect();
  const catalogId = props.dataItem?.catalogId as number | undefined;
  const categoryId = props.dataItem?.categoryId as number | undefined;
  const offlineSupplierId = props.dataItem?.offlineSupplierId as number | null | undefined;

  const handleOpenCatalog = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      stopPropagation(event);

      if (catalogId == null) {
        return;
      }

      redirect(
        getUrl('viewProductList')(
          catalogId.toString(),
          offlineSupplierId != null ? null : categoryId ?? null,
          offlineSupplierId ?? null
        ),
        false,
        true
      );
    },
    [catalogId, categoryId, getUrl, offlineSupplierId, redirect]
  );

  if (!value || catalogId == null) {
    return (
      <GridCellBase {...props} rowSelectionEnabled={false} title={value}>
        {value}
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        type="button"
        className="w-[100%] truncate rounded text-left text-[#0E80B4] hover:underline focus:outline-2 focus:outline-black"
        onClick={handleOpenCatalog}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default ShoppingCartCatalogCell;
